import React from "react";
import styles from "./tech-course-info-benefit.module.css";
import Button from "../button";
import ImageTag from "../image-tag";

const TechCourseInfoBenefit = ({ course, scrollToPayments }) => {
  const [showForm, setShowForm] = React.useState(false);

  // Flatten all cards from all columns in text_and_cards
  let allCards = [];
  if (course.text_and_cards && Array.isArray(course.text_and_cards)) {
    course.text_and_cards.forEach((item) => {
      [
        ...(item.cardFirstColumn || []),
        ...(item.secondColumnOne || []),
        ...(item.secondColumnTwo || []),
        ...(item.thirdColumn || []),
        ...(item.fourthColumn || []),
        ...(item.fifthColumn || []),
        ...(item.sixthColumn || [])
      ].forEach((card) => allCards.push(card));
    });
  }

  return (
    <section className={styles["section_no_background"]}>
      <div className={styles["what_block_body"]}>
        <div className={styles["parent_card_column"]}>
          {/* First column of cards */}
          <div className={styles["column_block"]}>
            {allCards.slice(0, 3).map((item, index) => (
              <div className={styles["card_column_item"]} key={index}>
                <ImageTag imageUrl={item?.icon?.url || item?.icon} alt={item?.name} />
                <div className={styles["column_item_title"]}>{item.title}</div>
                {item.text && <div className={styles["item_text"]}>{item.text}</div>}
              </div>
            ))}
          </div>

          {/* Second column of cards */}
          <div className={`${styles["column_block"]} ${styles["right"]}`}>
            {allCards.slice(3, 6).map((item, index) => (
              <div className={styles["card_column_item"]} key={index}>
                <ImageTag imageUrl={item?.icon?.url || item?.icon} alt={item?.name} />
                <div className={styles["column_item_title"]}>{item.title}</div>
                {item.text && <div className={styles["item_text"]}>{item.text}</div>}
              </div>
            ))}
          </div>
        </div>

        <div className={styles["what_text_parent"]}>
          <div className={`${styles["tag"]} ${styles["bonus_tag"]}`}>
            <span>+ BONUS: </span>
            {course.text_and_cards?.[0]?.topPill}
          </div>

          <div className={styles["what_title"]}>{course.text_and_cards?.[0]?.sectionTitle}</div>
          <div className={styles["what_text"]}>
            {course.text_and_cards?.[0]?.description}
          </div>

          <Button className={styles["enrol_btn"]} onClick={() => setShowForm(true)}>Join a Project</Button>
        </div>
      </div>

      {/* Modal for the form */}
      {showForm && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
          }}
          onClick={() => setShowForm(false)}
        >
          <div 
            style={{
              backgroundColor: 'white',
              borderRadius: '8px',
              width: '90%',
              maxWidth: '800px',
              height: '90%',
              maxHeight: '600px',
              position: 'relative',
              padding: '20px'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowForm(false)}
              style={{
                position: 'absolute',
                top: '10px',
                right: '15px',
                background: 'none',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                color: '#666'
              }}
            >
              ×
            </button>
            <iframe 
            title='Business Analysis Work Experience (Project-Based)'
            aria-label='Business Analysis Work Experience (Project-Based)' 
            frameBorder="0" 
            style={{
              height: '500px',
              width: '99%',
              border: 'none'
            }} 
            src='https://forms.zohopublic.com/info6463/form/BusinessAnalysisWorkExperienceProjectBased/formperma/4wqRaRle4RPPKYXJrDTcqonpUhKcy8rNgAEZ0kx3MIg'
          />
          </div>
        </div>
      )}
    </section>
  );
};

export default TechCourseInfoBenefit;
